import { Component } from '@angular/core';

@Component({
    selector: 'app-gaugesteps-data',
    templateUrl: './gaugesteps-data.component.html',
    styleUrl: './gaugesteps-data.component.css',
    standalone: false
})
export class GaugestepsDataComponent {

}
